import { RouteConfig } from 'vue-router';

const Shouye = () => import('./views/shouye/shouye.vue');
const Show = () => import('./views/show/show.vue');
const Tupian = () => import('./views/tupian/tupian.vue');


const routers: RouteConfig[] = [
    {
        path: 'shouye',
        component: Shouye,
    },
    {
        path: 'show',
        component: Show,
    },
    {
        path: 'tupian',
        component: Tupian,
    }
];

export default routers;

